import { ContactUs, CopyrightFooter } from 'app/components'
import { Container, IAppState } from 'app/containers/Container'
import * as React from 'react'

class IncomingContributionLeaders extends Container<{}, {}> {

  mapAppStateToContainerState(appState: IAppState): {} {
    return {}
  }

  render() {
    return (
      <section>
        <section className="margin-y-lg">
          <div className="container" style={{ overflowX: 'hidden' }}>
            <h1 className="animated fadeIn" style={{ textAlign: 'center', marginBottom: '20px' }}>
              Incoming Contribution Leaders
            </h1>
            <div style={{ textAlign: 'center', fontSize: '1.5rem', color: '#666' }}>
              Coming Soon - Please contact us for more information
            </div>
          </div>
        </section>

        <footer>
          <ContactUs />
          <CopyrightFooter />
        </footer>
      </section>
    )
  }
}

export {
  IncomingContributionLeaders
}


// WEBPACK FOOTER //
// ./src/app/containers/IncomingContributionLeaders/index.tsx